export const structureResponse = (data: any): any => {
  const { sys, ...rest } = data;
  return { sys, fields: rest.fields ?? rest };
};
